import { render, staticRenderFns } from "./Rentals.vue?vue&type=template&id=58b4c568&"
import script from "./Rentals.vue?vue&type=script&lang=js&"
export * from "./Rentals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports